import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import ButtonBackwardPreview from './ButtonBackwardPreview';
import ButtonForwardPreview from './ButtonForwardPreview';
import PlayMiniButton from './PlayMiniButton';
import ButtonPlay from './ButtonPlay';
import ButtonPause from './ButtonPause';

import useAutomixLoad from '../../automix/hooks/useAutomixLoad';

function ColumnActions({
  width,
  keyID, isPreview, isTablet,
  onClickPlayDeckA, onClickPlayDeckB,
  onPreviewBackward, onPreviewForward,
  enableActionsAutomix = true,
  isVisible = true
}) {
  const classNameDeckA = useSelector( state => (state.onAir && (state.onAir[0] === keyID)) ? 'deckA' : 'pmb-a' );
  const classNameDeckB = useSelector( state => (state.onAir && (state.onAir[1] === keyID)) ? 'deckB' : 'pmb-b' );
  const isReplay = useSelector( state => (state.replayTracks && state.replayTracks.includes(keyID)) );

  // Automix
  const { loadToAutomix, playpause, isPlaying, isCurrentPlayAutomix } = useAutomixLoad(keyID, enableActionsAutomix)

  return (
    <div style={{ width, display: 'flex', visibility: isVisible ? 'visible' : 'hidden', flexDirection: `row` }} >
      {
        (isPreview && !loadToAutomix) ? (
          <>
            <PlayMiniButton id={`L-PMB-${keyID}`} size={isTablet ? 36 : 20} direction={`left`}
              arrowColor={isReplay ? '#8F8F8F' : '#8C8C8C'} 
              className={classNameDeckA} onClick={onClickPlayDeckA} style={{ margin: `0px 1px`}} 
            />
            <PlayMiniButton id={`R-PMB-${keyID}`} size={isTablet ? 36 : 20} direction={`right`} 
              arrowColor={isReplay ? '#8F8F8F' : '#8C8C8C'} 
              className={classNameDeckB} onClick={onClickPlayDeckB} style={{ margin: `0px 1px`}} 
            />
          </>
        ) : ((isPreview && loadToAutomix) ? (isPlaying 
            ? ( isCurrentPlayAutomix 
                ? <ButtonPause className={'button-pause'} onClick={playpause} /> 
                : <ButtonPlay className={'button-play current'} onClick={playpause} /> ) 
            : <ButtonPlay className={'button-play'} onClick={loadToAutomix} />
        ) : (
          <>
            <ButtonBackwardPreview id={`L-PMB-${keyID}`} size={isTablet ? 36 : 20} direction={`left`} className={''} onClick={onPreviewBackward} style={{ margin: `0px 1px`}} />
            <ButtonForwardPreview id={`R-PMB-${keyID}`} size={isTablet ? 36 : 20} direction={`right`} className={''} onClick={onPreviewForward} style={{ margin: `0px 1px`}} />
          </>
       )) 
      }
    </div>
  )
}

ColumnActions.propTypes = {
  width: PropTypes.number.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired,
}

export default ColumnActions;
